import React, { useEffect, useState, useContext } from 'react';
import UserContext from "../context/UserContext";
import { api } from '../utils/apiHelper';
import '../styles/BidGallery.css';

const BidGallery = () => {
  const { authUser } = useContext(UserContext);
  const [bidItems, setBidItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [offers, setOffers] = useState({}); // Tracks offers per shortCode

  useEffect(() => {
    const fetchBidItems = async () => {
      try {
        const res = await api('/get-bid-items', 'GET');
        if (res.success) setBidItems(res.bidItems);
      } catch (err) {
        console.error('Error loading bid items:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBidItems();
  }, []);

          const handleOffer = async (item, offeredPrice) => {
  if (!authUser) {
    alert("You must sign in to make an offer.");
    return;
  }

  const newPrice = parseFloat(offeredPrice);
  if (isNaN(newPrice) || newPrice <= parseFloat(item.price)) {
    alert('Your offer must be higher than the current price.');
    return;
  }

  try {
    const res = await api('/update-bid-price', 'POST', {
      shortCode: item.shortCode,
      email: authUser.email,
      username: authUser.username,
      amount: newPrice
    });

    // Success
    if (res?.success) {
      alert('Offer submitted!');
      setBidItems((prevItems) =>
        prevItems.map((b) => (b._id === item._id ? { ...b, price: newPrice } : b))
      );
      setOffers((prev) => ({ ...prev, [item.shortCode]: '' }));
      return;
    }

    // Handle known backend errors
    const code = res?.errorCode || '';
    const msg = (res?.message || '').toLowerCase();

    // Missing shipping -> send to /settings
    if (code === 'MISSING_SHIPPING' || msg.includes('shipping address')) {
      alert('Please add a shipping address before making an offer. Redirecting to Settings…');
      window.location.href = '/settings'; // or use navigate('/settings') if you're using react-router
      return;
    }

    // Not signed in (defensive)
    if (code === 'NOT_AUTHENTICATED' || msg.includes('signed in')) {
      alert('You must sign in to make an offer.');
      return;
    }

    // Other errors
    alert(res?.message || 'Failed to submit offer.');
  } catch (err) {
    console.error('Error submitting offer:', err);
    alert('An error occurred submitting your offer.');
  }
};


  if (loading) return <p>Loading bid items...</p>;

  return (
    <div className="bid-gallery">
      <div><h1 className="bidley">The Great International Empire Auction</h1></div>
      {bidItems.map((item, index) => (
        <div key={index} className="bid-card">
        <div className="volume-title">
          <h3>{item.title}</h3>
          <h2>{item.ticketNumber} </h2>
          </div>
          <p>{item.description}</p>
          <p>Price: ${item.price}</p>
          <p className="productCode">Product Code: {item.shortCode}</p>
          {item.media && item.media.length > 0 && (
            <div className="media-preview">
              {item.media.map((url, i) =>
                url.endsWith('.mp4') ? (
                  <video key={i} controls src={url}></video>
                ) : (
                  <img key={i} src={url} alt={`file-${i}`} />
                )
              )}
            </div>
          )}
                      <input
                type="number"
                min={item.price}
                placeholder="Your offer"
                className="offer-input"
                value={offers[item.shortCode] || ''}
                onChange={(e) =>
                  setOffers({ ...offers, [item.shortCode]: e.target.value })
                }
              />
              <button
                className="offer-button"
                onClick={() => handleOffer(item, offers[item.shortCode])}
              >
                Make Offer
              </button>
                      </div>
                    ))}
                  </div>
  );
};

export default BidGallery;
